'use client';

import React, { HTMLAttributes, useState } from 'react';
import { AnimatedButton } from '@/components/AnimatedButton';
import { IoCloseSharp } from 'react-icons/io5';

import { IDiscoverSicilySubpages } from '@/dictionaries/pages/discoverSicily/types';

import { IDiscoverPugliaSubpages } from '@/dictionaries/pages/discoverPuglia/types';

import { SideNavigatorTab } from './SideNavigatorTab';

interface ISideNavigatorModalProps extends HTMLAttributes<HTMLDivElement> {
  dict: IDiscoverSicilySubpages | IDiscoverPugliaSubpages;
  currentPage: string;
  changeModalIsOpen: (state: boolean) => void;
  modalIsOpen: boolean;
}

interface ISideNavigatorProps extends HTMLAttributes<HTMLDivElement> {
  dict: IDiscoverSicilySubpages | IDiscoverPugliaSubpages;
  currentPage: string;
}

interface ISideNavigatorButtonProps extends HTMLAttributes<HTMLButtonElement> {
  dict: IDiscoverSicilySubpages | IDiscoverPugliaSubpages;
}

export const SideNavigatorModal: React.FC<ISideNavigatorModalProps> = ({
  dict,
  currentPage,
  modalIsOpen,
  changeModalIsOpen,
}) => {
  return modalIsOpen ? (
    <div
      onClick={(e) => e.target === e.currentTarget && changeModalIsOpen(false)}
      className={`flex flex-col overflow-auto transition-opacity duration-300 fixed z-50 top-0 left-0 w-full h-full bg-white bg-opacity-90 overlay`}>
      <div
        onClick={(e) => e.preventDefault()}
        className={`flex flex-col desktop:flex-row desktop:w-[650px] w-full float-none z-50 text-gray-700 bg-white px-8 py-5 h-full shadow-md`}>
        <div className="w-full h-full relative">
          <div
            className="absolute top-[10px] right-[15px] cursor-pointer"
            onClick={() => changeModalIsOpen(false)}>
            <IoCloseSharp className="w-8 h-8 text-gray-500" />
          </div>
          <div className="p-0 overflow-auto border-r-0">
            {dict.content.tabs.map((tab, index) => (
              <SideNavigatorTab
                key={index}
                tab={tab}
                currentPage={currentPage}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export const SideNavigatorButton: React.FC<ISideNavigatorButtonProps> = ({
  dict,
  onClick,
}) => {
  return (
    <div className="sticky h-[550px] top-0 w-[8.33333%] hidden desktop:flex justify-end items-start z-10">
      <div className="h-full w-full relative">
        <div className="absolute top-[38%] translate-y-1/2 left-[calc(50%-40px)] ">
          <div className="-rotate-90 ">
            <AnimatedButton
              className="h-fit w-fit !min-w-14 flex !mt-auto"
              onClick={onClick}>
              <span className="!w-fit m-auto !font-text text-center text-gray-900 filter-none">
                {dict.content.title}
              </span>
            </AnimatedButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SideNavigator: React.FC<ISideNavigatorProps> = ({
  dict,
  currentPage,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <SideNavigatorModal
        dict={dict}
        currentPage={currentPage}
        changeModalIsOpen={(state) => {
          setModalIsOpen(state);
        }}
        modalIsOpen={modalIsOpen}
      />
      <SideNavigatorButton dict={dict} onClick={() => setModalIsOpen(true)} />
    </>
  );
};
